(() => {
  if (window.Torras24HCartAvailability) {
    window.Torras24HCartAvailability.refresh();
    return;
  }

  let refreshTimer = 0;
  let refreshSequence = 0;

  function scheduleRefresh() {
    window.clearTimeout(refreshTimer);
    refreshTimer = window.setTimeout(refresh, 40);
  }

  function parseConfig(notice) {
    try {
      return JSON.parse(
        notice.querySelector("[data-24h-cart-notice-config]")?.textContent ||
          "{}",
      );
    } catch {
      return {};
    }
  }

  function hideNotice(notice) {
    notice.hidden = true;
  }

  function renderNotice(notice, strings) {
    notice.classList.add("delivery-24h-cart-notice--express");
    const title = notice.querySelector("[data-24h-cart-notice-title]");
    const body = notice.querySelector("[data-24h-cart-notice-body]");
    const titleText = strings.expressTitle || "";
    const bodyText = strings.expressBody || "";
    if (title?.textContent !== titleText) title.textContent = titleText;
    if (body?.textContent !== bodyText) body.textContent = bodyText;
    const icon = notice.querySelector("[data-24h-cart-notice-icon]");
    if (icon?.textContent !== "★") icon.textContent = "★";
    notice.hidden = false;
  }

  async function refresh() {
    const sequence = ++refreshSequence;
    const notices = [...document.querySelectorAll("[data-24h-cart-notice]")];
    const badges = [...document.querySelectorAll("[data-24h-cart-badge]")];
    if (!notices.length && !badges.length) return;

    const noticeConfigs = notices.map((notice) => ({
      notice,
      config: parseConfig(notice),
    }));
    const ids = [
      ...new Set([
        ...noticeConfigs.flatMap(({ config }) =>
          (config.items || []).map((item) => String(item.variantId || "")),
        ),
        ...badges.map((badge) => String(badge.dataset.variantId || "")),
      ]),
    ].filter(Boolean);

    const availability = window.Torras24HAvailability;
    if (!availability?.configured) {
      badges.forEach((badge) => {
        badge.hidden = true;
      });
      noticeConfigs.forEach(({ notice }) => hideNotice(notice));
      return;
    }

    try {
      const quantities = await availability.check(ids);
      if (sequence !== refreshSequence) return;

      badges.forEach((badge) => {
        const requiredQuantity = Math.max(
          1,
          Number(badge.dataset.quantity) || 1,
        );
        badge.hidden =
          (quantities.get(String(badge.dataset.variantId || "")) || 0) <
          requiredQuantity;
      });

      noticeConfigs.forEach(({ notice, config }) => {
        const physicalItems = (config.items || []).filter(
          (item) => item.requiresShipping !== false,
        );
        const allItemsEligible =
          physicalItems.length > 0 &&
          physicalItems.every(
            (item) =>
              item.standardDelivery !== false &&
              (quantities.get(String(item.variantId || "")) || 0) >=
              Math.max(1, Number(item.quantity) || 1),
          );
        if (allItemsEligible) {
          renderNotice(notice, config.strings || {});
        } else {
          hideNotice(notice);
        }
      });
    } catch {
      if (sequence !== refreshSequence) return;
      badges.forEach((badge) => {
        badge.hidden = true;
      });
      noticeConfigs.forEach(({ notice }) => hideNotice(notice));
    }
  }

  window.Torras24HCartAvailability = { refresh, scheduleRefresh };
  document.addEventListener("torras:24h-availability-ready", scheduleRefresh);
  new MutationObserver(scheduleRefresh).observe(document.body, {
    childList: true,
    subtree: true,
  });
  scheduleRefresh();
})();
